import React, { useState, useEffect } from "react"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import FieldWrap, { Req, SubmitGroup } from "../../Forms/FieldWrap"
import Button from "../../Button/Button"
import SendIcon from "../../../images/send-svgrepo-com.svg"
import styled from "styled-components/macro"
import colors from "../../../scripts/colors"
import {
  FaExclamationCircle,
  FaUndoAlt,
  FaSpinner,
  FaCheck,
} from "react-icons/fa"
import "@fontsource/noto-sans-jp/700.css"
import axios from "axios"

const schema = yup.object().shape({
  firstName: yup.string().required("Required"),
  lastName: yup.string().required("Required"),
  email: yup.string().email("Not an email").required("Required"),
  phone: yup.string(),
  message: yup.string().required("Required"),
})

const FormStyles = styled.form`
  margin-top: -50px;
  padding-top: 50px;
`

const ErrorMessage = styled.p`
  text-transform: uppercase;
  font-family: "Noto Sans JP", sans-serif;
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  margin: 5px 0 0;
  color: ${colors("red")};
  svg {
    margin-right: 5px;
  }
`

const HomePageContactform = ({ facilityEmail }) => {
  const [submitState, setSubmitState] = useState("ready")

  // useEffect(() => {
  //   console.log(submitState)
  // }, [submitState])

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })
  const onSubmit = data => {
    setSubmitState("submitting")

    axios
      .post("/.netlify/functions/postmarkSend", {
        ...data,
        facilityEmail,
      })
      .then((res: any) => {
        setSubmitState("sent")
      })
      .catch((err: any) => console.log(err))
  }

  return (
    <FormStyles
      id="HomePage-contactForm"
      onSubmit={handleSubmit(onSubmit)}
      role="form"
    >
      <FieldWrap width="48%" error={errors.firstName} label="First Name" req>
        <input type="text" {...register("firstName")} />
        {errors.firstName && (
          <ErrorMessage>
            <FaExclamationCircle /> {errors.firstName?.message}
          </ErrorMessage>
        )}
      </FieldWrap>

      <FieldWrap width="48%" error={errors.lastName} label="Last Name" req>
        <input type="text" {...register("lastName")} />
        {errors.lastName && (
          <ErrorMessage>
            <FaExclamationCircle /> {errors.lastName?.message}
          </ErrorMessage>
        )}
      </FieldWrap>

      <FieldWrap width="48%" error={errors.email} label="Email" req>
        <input type="email" {...register("email")} />
        {errors.email && (
          <ErrorMessage>
            <FaExclamationCircle /> {errors.email?.message}
          </ErrorMessage>
        )}
      </FieldWrap>

      <FieldWrap width="48%" label="Phone">
        <input type="tel" {...register("phone")} />
      </FieldWrap>

      <FieldWrap error={errors.message} label="Message" req>
        <textarea {...register("message")} />
        {errors.message && (
          <ErrorMessage>
            <FaExclamationCircle /> {errors.message?.message}
          </ErrorMessage>
        )}
      </FieldWrap>

      <SubmitGroup>
        {submitState === "ready" && (
          <Button
            id="ContactForm-submitButton"
            type="submit"
            icon={<SendIcon />}
          >
            Submit
          </Button>
        )}

        {submitState === "submitting" && (
          <Button
            id="ContactForm-sendingIndicator"
            icon={<FaSpinner />}
            element="div"
          >
            Sending
          </Button>
        )}

        {submitState === "sent" && (
          <>
            <Button
              id="ContactForm-sentIndicator"
              icon={<FaCheck />}
              element="div"
            >
              Sent
            </Button>
            <Button
              id="ContactForm-resetButton"
              type="reset"
              icon={<FaUndoAlt />}
              onClick={() => {
                reset()
                setSubmitState("ready")
              }}
            >
              Reset
            </Button>
          </>
        )}
      </SubmitGroup>
    </FormStyles>
  )
}

export default HomePageContactform
